import { TSelectData } from '@components/formFields/select/types'
import { TListTypes, LIST_TYPES } from '@global/types'
import { ApiResponseTemplate } from '@templates/types'

interface ISelectedColumns {
  listType: TListTypes
  templateFields: ApiResponseTemplate['template_fields']
  selectedTemplateColumn: TSelectData | null
}

type ReturnSelectedColumns = string[]

export function getSelectedColumns({
  listType,
  templateFields,
  selectedTemplateColumn,
}: ISelectedColumns): ReturnSelectedColumns {
  const createColumnsForMutation = tf => [tf.id, String(tf.field?.id)] as [number, string]
  const columns = templateFields.map(createColumnsForMutation)

  if (listType === LIST_TYPES.dropDown) {
    const selectedFieldID =
      columns.find(([id, _fieldId]) => id === selectedTemplateColumn?.id)?.[1] ?? '*'
    return [selectedFieldID]
  }

  return columns.map(([, v]) => v)
}
